import { motion } from "framer-motion";
import { useLanguage, IMG_ABOUT } from "@/i18n";

export const About = () => {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative order-2 lg:order-1"
        >
          <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-xl">
            <img src={IMG_ABOUT} alt="Modern company" className="w-full h-[420px] object-cover" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="order-1 lg:order-2"
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600">{a.overline}</span>
          <h2
            className="mt-4 text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            {a.title}
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">{a.p1}</p>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">{a.p2}</p>

          <div className="mt-10 grid grid-cols-3 gap-4">
            {a.stats.map((st, i) => (
              <div key={i} data-testid={`about-stat-${i}`} className="rounded-2xl border border-slate-200 bg-[#F8F9FA] p-5">
                <div
                  className="text-lg md:text-xl font-bold text-slate-900"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                >
                  {st.value}
                </div>
                <div className="mt-1 text-sm text-slate-500">{st.label}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
